import { Drawer as AntdDrawer } from 'antd';
import styled from 'styled-components';

const Drawer = styled(AntdDrawer)`
  .ant-drawer-content-wrapper {
    padding: 0;
  }
  .ant-tabs-nav {
    margin-bottom: 0;
  }
  .ant-drawer-header {
    background: transparent;
    padding: 25px;
  }
  .ant-drawer-close {
    top: 0;
    padding: 10px;
  }
`;
export default Drawer;
